import React, { Component } from 'react';
import { Container, Paper, CssBaseline, Avatar, Button, TextField, Typography, InputAdornment } from '@material-ui/core';
import './signIn.css';
import logo from '../../../assets/image/stayplease-big.png';
import { Mail, Lock } from '@material-ui/icons';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Toast from 'antd-mobile/lib/toast';
import packageJson from '../../../../package.json';
import localStorage from '../../../utils/localStorage';
import { setAdminLanguage, initializeAdminLanguage } from '../../i18n/adminI18n';
import adminI18n from '../../i18n/adminI18n';
import { withTranslation } from 'react-i18next';

const useStyles = theme => ({
    paper: {
        // marginTop: theme.spacing(8),
        paddngTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
});

@inject('authStore')
@observer
class AdminLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signInEmail: '',
            signInPassword: ''
        }
    }

    componentDidMount() {
        this.handleAdminLanguageParameter();

        if (this.props.match.params.token === undefined) {
            this.props.authStore.removeAdminInfo();
        } else {
            this.props.authStore.adminLoginToken(this.props.match.params.token).then((adminLoginResponse) => {
                if (adminLoginResponse) {
                    if (adminLoginResponse.isError) {
                        Toast.fail(adminLoginResponse.errorMessage, 2);
                    }
                    else {
                        if (adminLoginResponse.userModel) {
                            localStorage.Save('adminLoginName', adminLoginResponse.userModel.loginName);
                            localStorage.Save('adminLoginRole', adminLoginResponse.userModel.role);
                            localStorage.Save('adminLoginToken', adminLoginResponse.userModel.token);
                            this.props.history.push('/admin/item');
                        } else {
                            Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
                        }
                    }
                } else {
                    Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
                }
            }, err => {
                console.log(err);
                Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
            })
        }
    }

    handleAdminLanguageParameter = () => {
        const { language } = this.props.match.params;

        // 如果URL中有语言参数，尝试设置它
        if (language) {
            const success = setAdminLanguage(language);
            if (success) {
                console.log(`Admin language parameter received and set: ${language}`);
            } else {
                console.warn(`Unsupported admin language parameter: ${language}, falling back to saved or default language`);
                // 初始化为保存的语言或默认语言
                initializeAdminLanguage();
            }
        } else {
            // 如果没有语言参数，初始化为保存的语言或默认语言
            initializeAdminLanguage();
        }
    }

    // ON CHANGE

    userNameOnChange = (e) => {
        this.setState({
            signInEmail: e.target.value
        });
    }

    passwordOnChange = (e) => {
        this.setState({
            signInPassword: e.target.value
        });
    }

    // ON CLICK

    adminLoginOnClick = () => {
        const { signInEmail, signInPassword } = this.state;

        this.props.authStore.adminLogin(signInEmail, signInPassword).then((adminLoginResponse) => {
            if (adminLoginResponse) {
                if (adminLoginResponse.isError) {
                    Toast.fail(adminLoginResponse.errorMessage, 2);
                }
                else {
                    if (adminLoginResponse.userModel) {
                        localStorage.Save('adminLoginName', adminLoginResponse.userModel.loginName);
                        localStorage.Save('adminLoginPassword', adminLoginResponse.userModel.password);
                        localStorage.Save('adminLoginRole', adminLoginResponse.userModel.role);
                        this.props.history.push('/admin/item');
                    } else {
                        Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
                    }
                }
            } else {
                Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
            }

        }, err => {
            console.log(err);
            Toast.fail('Unexpected issue occured. Please contact your administrator.', 2);
        })
    }

    render() {
        const { signInEmail, signInPassword } = this.state;
        const { classes, t } = this.props;
        const { adminLoginLoading } = this.props.authStore;

        if (adminLoginLoading) {
            Toast.loading(t('Loading...'), 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <Container className='blue' component='main' maxWidth='xs'>
                <CssBaseline />
                <div className={classes.paper}>
                    <img src={logo} alt='StayPlease' width='200px' style={{ marginTop: 50 }} />
                    <Paper style={{ padding: 20, marginBottom: 20, width: 375 }}>
                        <div style={{ textAlign: 'center' }}>
                            <Avatar className={classes.avatar} style={{ marginLeft: '45%' }}>
                                <LockOutlinedIcon />
                            </Avatar>
                            <Typography component='h1' variant='h5'>
                                {`${packageJson.name.toUpperCase()} v${packageJson.version}`}<br />{t('Content Management System')}
                            </Typography>
                        </div>

                        <form className={classes.form} noValidate>
                            <TextField
                                id='userName'
                                placeholder={t('Username')}
                                margin='normal'
                                type='email'
                                fullWidth
                                value={signInEmail}
                                onChange={this.userNameOnChange}
                                autoComplete="username"
                                InputProps={
                                    {
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Mail />
                                            </InputAdornment>
                                        )
                                    }
                                }
                                className='login-form-field'
                            />

                            <TextField
                                id='loginPassword'
                                type='password'
                                placeholder={t('Password')}
                                margin='normal'
                                fullWidth
                                value={signInPassword}
                                onChange={this.passwordOnChange}
                                autoComplete="current-password"
                                InputProps={
                                    {
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Lock />
                                            </InputAdornment>
                                        )
                                    }
                                }
                                className='login-form-field'
                            />

                            <Button
                                variant='contained'
                                color='secondary'
                                fullWidth
                                onClick={this.adminLoginOnClick}
                                style={{ marginTop: 20 }}
                            >
                                {t('LOGIN')}
                            </Button>

                        </form>
                    </Paper>
                </div>
            </Container>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(withStyles(useStyles)(AdminLoginPage));